export default __webpack_public_path__ + "static/media/T344_T346MAND4.b2df8ae4.pdf";